import React, { useEffect, useState, useCallback } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { TabView, TabPanel } from "primereact/tabview";
import { Dropdown } from "primereact/dropdown";
import { fetchWithAuth, API_URL } from "../Componentes/fetchWithAuth";
import "../styles/Paises.css";

const Paises = ({ language }) => {
  // ==============================================
  // Estados Generales para Pestañas
  // ==============================================
  const [activeIndex, setActiveIndex] = useState(0);

  // ==============================================
  // Estados y Lógica para PAISES
  // ==============================================
  const [paises, setPaises] = useState([]);
  const [filteredPaises, setFilteredPaises] = useState([]);
  const [searchTextPaises, setSearchTextPaises] = useState("");
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [selectedCountryId, setSelectedCountryId] = useState(null); // [EXPERT_ANALYSIS]: QUÉ: Se añade un nuevo estado para el ID del país seleccionado. - POR QUÉ: Es necesario para mantener un registro del país seleccionado y usarlo como dependencia para filtrar los departamentos de manera reactiva. - IMPACTO: Permite la comunicación de estado entre la tabla de países y la lógica de filtrado de departamentos.
  const [displayCountryModal, setDisplayCountryModal] = useState(false);
  const [countryFormData, setCountryFormData] = useState({
    sNombrePais: "",
    idpais: "", // [EXPERT_ANALYSIS]: QUÉ: Se cambia `iCodPaises` a `idpais` en el estado inicial. - POR QUÉ: Para alinear la convención de nombres de propiedades con la respuesta del backend, que utiliza `idpais`. - IMPACTO: Asegura que los datos del país se manejen consistentemente en el formulario.
  });
  const [isEditModeCountry, setIsEditModeCountry] = useState(false);

  // ==============================================
  // Estados y Lógica para DEPARTAMENTOS
  // ==============================================
  const [departamentos, setDepartamentos] = useState([]);
  const [filteredDepartamentos, setFilteredDepartamentos] = useState([]);
  const [searchTextDepartamentos, setSearchTextDepartamentos] = useState("");
  const [selectedDepartamento, setSelectedDepartamento] = useState(null);
  // [EXPERT_ANALYSIS]: QUÉ: Se añade un nuevo estado para el ID del departamento seleccionado. - POR QUÉ: Es necesario para mantener un registro del departamento seleccionado y usarlo como dependencia para filtrar las ciudades de manera reactiva. - IMPACTO: Permite la comunicación de estado entre la tabla de departamentos y la lógica de filtrado de ciudades.
  const [selectedDepartamentoId, setSelectedDepartamentoId] = useState(null); // [EXPERT_COMMENT]: Nuevo estado para el ID del departamento seleccionado.
  const [displayDepartamentoModal, setDisplayDepartamentoModal] =
    useState(false);
  const [departamentoFormData, setDepartamentoFormData] = useState({
    sNombreDepartamento: "",
    iddepartamento: "", // [EXPERT_ANALYSIS]: QUÉ: Se cambia `iCodDepartamento` a `iddepartamento` en el estado inicial. - POR QUÉ: Para alinear la convención de nombres de propiedades con la respuesta del backend, que utiliza `iddepartamento`. - IMPACTO: Asegura que los datos del departamento se manejen consistentemente en el formulario.
    idpais: "", // [EXPERT_ANALYSIS]: QUÉ: Se cambia `iCodPaises` a `idpais` en el estado inicial. - POR QUÉ: Para alinear la convención de nombres de propiedades con la respuesta del backend, que utiliza `idpais`. - IMPACTO: Asegura que los datos del país se manejen consistentemente en el formulario.
  });
  const [isEditModeDepartamento, setIsEditModeDepartamento] = useState(false);

  // ==============================================
  // Estados y Lógica para CIUDADES
  // ==============================================
  const [ciudades, setCiudades] = useState([]);
  const [filteredCiudades, setFilteredCiudades] = useState([]);
  const [searchTextCiudades, setSearchTextCiudades] = useState("");
  const [selectedCiudad, setSelectedCiudad] = useState(null);
  const [displayCiudadModal, setDisplayCiudadModal] = useState(false);
  const [ciudadFormData, setCiudadFormData] = useState({
    sNombreCiudad: "",
    iCodCiudad: "",
    iddepartamento: "", // [EXPERT_ANALYSIS]: Unificado con el backend.
    idpais: "",
  });
  const [isEditModeCiudad, setIsEditModeCiudad] = useState(false);
  const [isDuplicateCode, setIsDuplicateCode] = useState(false); // [EXPERT_ANALYSIS]: Estado para feedback visual de duplicados.
  const [
    departamentosFiltradosParaCiudad,
    setDepartamentosFiltradosParaCiudad,
  ] = useState([]);

  // ==============================================
  // Traducciones
  // ==============================================
  const getTranslations = (lang) => {
    const translations = {
      es: {
        titlePaises: "Gestión de Países",
        titleDepartamentos: "Gestión de Departamentos",
        titleCiudades: "Gestión de Ciudades",
        searchPlaceholder: "Buscar...",
        columnsPaises: [
          { field: "idpais", header: "Código" }, // [EXPERT_ANALYSIS]: QUÉ: Se cambia `iCodPaises` a `idpais` en la definición de columnas. - POR QUÉ: Para que la tabla muestre el valor correcto del ID del país, ya que el backend lo devuelve como `idpais`. - IMPACTO: La tabla de países mostrará el ID correcto.
          { field: "sNombrePais", header: "Nombre del País" },
        ],
        columnsDepartamentos: [
          { field: "iddepartamento", header: "Código" }, // [EXPERT_ANALYSIS]: QUÉ: Se cambia `iCodDepartamento` a `iddepartamento` en la definición de columnas. - POR QUÉ: El backend devuelve el ID del departamento como `iddepartamento` (línea 33 y 71 de `backend/routes/getdepartamentos.js`). Esta corrección asegura que la tabla de departamentos muestre el valor correcto del ID. - IMPACTO: El código del departamento se mostrará correctamente en la tabla.
          { field: "sNombreDepartamento", header: "Nombre del Departamento" },
          { field: "sNombrePais", header: "País" },
        ],
        columnsCiudades: [
          { field: "iCodCiudad", header: "Código" },
          { field: "sNombreCiudad", header: "Nombre de la Ciudad" },
          { field: "sNombreDepartamento", header: "Departamento" },
          { field: "sNombrePais", header: "País" },
        ],
        newHeader: "Nuevo {entity}",
        editHeader: "Editar {entity}",
        saveButton: "Guardar",
        cancelButton: "Cancelar",
        newButton: "Nuevo",
        editButton: "Editar",
        deleteButton: "Eliminar",
        codeLabel: "Código",
        nameLabel: "Nombre",
        countryLabel: "País",
        departmentLabel: "Departamento",
        selectEntityAlert: "Por favor, selecciona un/a {entity} para editar.",
        confirmDelete:
          "¿Estás seguro de que quieres eliminar {theEntity} {entityName}?",
        deleteSuccess: "{Entity} eliminado/a exitosamente.",
        deleteError: "Error al eliminar {theEntity}: ",
        nameEmptyAlert: "El nombre de {theEntity} no puede estar vacío.",
        codeEmptyAlert: "El código de {theEntity} no puede estar vacío.",
        createSuccess: "{Entity} creado/a exitosamente.",
        createError: "Error al crear {theEntity}: ",
        editSuccess: "{Entity} actualizado/a exitosamente.",
        editError: "Error al actualizar {theEntity}: ",
        entityNotFound: "{Entity} no encontrado/a.",
        hasChildren:
          "No se puede eliminar {theEntity} porque tiene {childEntity} asociado/a(s).",
        mustBeAssociated:
          "El/La {entity} debe estar asociado/a a un/a {parentEntity}.",
        gestion_ubicaciones: "Gestión de Ubicaciones",
      },
      en: {
        titlePaises: "Countries Management",
        titleDepartamentos: "Departments Management",
        titleCiudades: "Cities Management",
        searchPlaceholder: "Search...",
        columnsPaises: [
          { field: "idpais", header: "Code" }, // [EXPERT_ANALYSIS]: QUÉ: Se cambia `iCodPaises` a `idpais` en la definición de columnas. - POR QUÉ: Para que la tabla muestre el valor correcto del ID del país, ya que el backend lo devuelve como `idpais`. - IMPACTO: La tabla de países mostrará el ID correcto.
          { field: "sNombrePais", header: "Country Name" },
        ],
        columnsDepartamentos: [
          { field: "iddepartamento", header: "Code" }, // [EXPERT_ANALYSIS]: QUÉ: Se cambia `iCodDepartamento` a `iddepartamento` en la definición de columnas. - POR QUÉ: Para que la tabla muestre el valor correcto del ID del departamento, ya que el backend lo devuelve como `iddepartamento`. - IMPACTO: La tabla de departamentos mostrará el ID correcto.
          { field: "sNombreDepartamento", header: "Department Name" },
          { field: "sNombrePais", header: "Country" },
        ],
        columnsCiudades: [
          { field: "iCodCiudad", header: "Code" },
          { field: "sNombreCiudad", header: "City Name" },
          { field: "sNombreDepartamento", header: "Department" },
          { field: "sNombrePais", header: "Country" },
        ],
        newHeader: "New {entity}",
        editHeader: "Edit {entity}",
        saveButton: "Save",
        cancelButton: "Cancel",
        newButton: "New",
        editButton: "Edit",
        deleteButton: "Delete",
        codeLabel: "Code",
        nameLabel: "Name",
        countryLabel: "Country",
        departmentLabel: "Department",
        selectEntityAlert: "Please select a {entity} to edit.",
        confirmDelete:
          "Are you sure you want to delete {theEntity} {entityName}?",
        deleteSuccess: "{Entity} deleted successfully.",
        deleteError: "Error deleting {theEntity}: ",
        nameEmptyAlert: "The name of {theEntity} cannot be empty.",
        codeEmptyAlert: "The code of {theEntity} cannot be empty.",
        createSuccess: "{Entity} created successfully.",
        createError: "Error creating {theEntity}: ",
        editSuccess: "{Entity} updated successfully.",
        editError: "Error updating {theEntity}: ",
        entityNotFound: "{Entity} not found.",
        hasChildren:
          "Cannot delete {theEntity} because it has associated {childEntity}(s).",
        mustBeAssociated:
          "The {entity} must be associated with a {parentEntity}.",
        gestion_ubicaciones: "Locations Management",
      },
      zh: {
        titlePaises: "国家管理",
        titleDepartamentos: "部门管理",
        titleCiudades: "城市管理",
        searchPlaceholder: "搜索...",
        columnsPaises: [
          { field: "idpais", header: "代码" }, // [EXPERT_ANALYSIS]: QUÉ: Se cambia `iCodPaises` a `idpais` en la definición de columnas. - POR QUÉ: Para que la tabla muestre el valor correcto del ID del país, ya que el backend lo devuelve como `idpais`. - IMPACTO: La tabla de países mostrará el ID correcto.
          { field: "sNombrePais", header: "国家名称" },
        ],
        columnsDepartamentos: [
          { field: "iddepartamento", header: "代码" }, // [EXPERT_ANALYSIS]: QUÉ: Se cambia `iCodDepartamento` a `iddepartamento` en la definición de columnas. - POR QUÉ: Para que la tabla muestre el valor correcto del ID del departamento, ya que el backend lo devuelve como `iddepartamento`. - IMPACTO: La tabla de departamentos mostrará el ID correcto.
          { field: "sNombreDepartamento", header: "部门名称" },
          { field: "sNombrePais", header: "国家" },
        ],
        columnsCiudades: [
          { field: "iCodCiudad", header: "代码" },
          { field: "sNombreCiudad", header: "城市名称" },
          { field: "sNombreDepartamento", header: "部门" },
          { field: "sNombrePais", header: "国家" },
        ],
        newHeader: "新建{entity}",
        editHeader: "编辑{entity}",
        saveButton: "保存",
        cancelButton: "取消",
        newButton: "新建",
        editButton: "编辑",
        deleteButton: "删除",
        codeLabel: "代码",
        nameLabel: "名称",
        countryLabel: "国家",
        departmentLabel: "部门",
        selectEntityAlert: "请选择要编辑的{entity}。",
        confirmDelete: "您确定要删除{theEntity} {entityName} 吗？",
        deleteSuccess: "{Entity} 删除成功。",
        deleteError: "删除{theEntity}时出错：",
        nameEmptyAlert: "{theEntity} 的名称不能为空。",
        codeEmptyAlert: "{theEntity} 的代码不能为空。",
        createSuccess: "{Entity} 创建成功。",
        createError: "创建{theEntity}时出错：",
        editSuccess: "{Entity} 更新成功。",
        editError: "更新{entity}时出错：",
        entityNotFound: "{Entity} 未找到。",
        hasChildren: "无法删除{theEntity}，因为它有相关的{childEntity}。",
        mustBeAssociated: "{entity} 必须与 {parentEntity} 关联。",
        gestion_ubicaciones: "地点管理",
      },
    };
    return translations[lang] || translations.es;
  };

  const translations = getTranslations(language);
  const {
    titlePaises,
    titleDepartamentos,
    titleCiudades,
    searchPlaceholder,
    columnsPaises,
    columnsDepartamentos,
    columnsCiudades,
    newHeader,
    editHeader,
    saveButton,
    cancelButton,
    newButton,
    editButton,
    codeLabel,
    nameLabel,
    countryLabel,
    departmentLabel,
    selectEntityAlert,
    nameEmptyAlert,
    codeEmptyAlert,
    createSuccess,
    createError,
    editSuccess,
    editError,
    mustBeAssociated,
  } = translations;

  // ==============================================
  // Funciones de Carga de Datos
  // ==============================================

  // Cargar Países
  const fetchPaises = useCallback(async () => {
    try {
      const response = await fetchWithAuth(`${API_URL}/api/paises`);
      if (!response.ok) throw new Error("Error al cargar países");
      const data = await response.json();
      setPaises(data);
      setFilteredPaises(data);
    } catch (err) {
      console.error("Error al cargar países:", err);
      alert(`Error al cargar países: ${err.message}`);
    }
  }, []);

  // [EXPERT_ANALYSIS]: QUÉ: Se modifica la función `fetchDepartamentos` para aceptar un `idPais` opcional. - POR QUÉ: Permite reutilizar la misma función para cargar todos los departamentos o filtrar por un país específico, reduciendo la duplicidad de código y mejorando la mantenibilidad. - IMPACTO: Simplifica la lógica de carga de datos y centraliza la gestión de departamentos.
  const fetchDepartamentos = useCallback(
    async (idPais = null) => {
      try {
        const url = idPais
          ? `${API_URL}/api/departamentos/${idPais}`
          : `${API_URL}/api/departamentos`;
        const response = await fetchWithAuth(url);
        if (!response.ok) {
          throw new Error(
            `Error al cargar departamentos${idPais ? ` para el país ${idPais}` : ""}`,
          );
        }
        const data = await response.json();
        const processedData = data;

        const departamentosConPais = processedData.map((departamento) => {
          let sNombrePaisAsociado = "Desconocido";

          if (idPais) {
            const paisFiltrado = paises.find((pais) => pais.idpais === idPais);
            if (paisFiltrado) {
              sNombrePaisAsociado = paisFiltrado.sNombrePais;
            }
          } else if (departamento.iCodPais && paises.length > 0) {
            const paisCorrespondiente = paises.find(
              (pais) => pais.idpais === departamento.iCodPais,
            );
            sNombrePaisAsociado = paisCorrespondiente
              ? paisCorrespondiente.sNombrePais
              : "Desconocido";
          } else if (departamento.idpais && paises.length > 0) {
            const paisCorrespondiente = paises.find(
              (pais) => pais.idpais === departamento.idpais,
            );
            sNombrePaisAsociado = paisCorrespondiente
              ? paisCorrespondiente.sNombrePais
              : "Desconocido";
          }

          return {
            ...departamento,
            idpais: departamento.idpais || departamento.iCodPais || idPais,
            sNombrePais: sNombrePaisAsociado,
          };
        });

        setDepartamentos(departamentosConPais);
        setFilteredDepartamentos(departamentosConPais);
      } catch (err) {
        console.error("Error al cargar departamentos:", err);
        alert(`Error al cargar departamentos: ${err.message}`);
      }
    },
    [paises],
  );

  // [EXPERT_ANALYSIS]: QUÉ: Se elimina la función `fetchDepartamentosPorPais`. - POR QUÉ: Su funcionalidad ha sido integrada en la función `fetchDepartamentos`, haciendo esta función redundante. - IMPACTO: Reduce la duplicidad de código y simplifica la base de código.
  // const fetchDepartamentosPorPais = async (paisId) => {
  //   try {
  //     const response = await fetchWithAuth(`${API_URL}/api/departamentos?paisId=${paisId}`);
  //     if (!response.ok) throw new Error("Error al cargar departamentos por país");
  //     const data = await response.json();
  //     const processedData = Array.isArray(data) && Array.isArray(data) ? data : data;
  //     setDepartamentosFiltradosParaCiudad(processedData);
  //   } catch (err) {
  //     console.error(`Error al cargar departamentos para el país ${paisId}:`, err);
  //     setDepartamentosFiltradosParaCiudad([]);
  //     alert(`Error al cargar departamentos para el país seleccionado: ${err.message}`);
  //   }
  // };

  // [EXPERT_ANALYSIS]: QUÉ: Se modifica la función `fetchCiudades` para aceptar `idDepartamento` y `idPais` opcionales. - POR QUÉ: Permite cargar ciudades basándose en un departamento específico, un país específico, o todas las ciudades, centralizando la lógica de carga y mejorando la flexibilidad. - IMPACTO: Habilita el filtrado en cascada (País -> Departamento -> Ciudad) y reduce la duplicidad de código.
  const fetchCiudades = useCallback(
    async (idDepartamento = null, idPais = null) => {
      console.info(
        `[FETCH_DEBUG]: Iniciando fetchCiudades. deptoId: ${idDepartamento}, paisId: ${idPais}`,
      );
      try {
        let url = `${API_URL}/api/ciudades`;
        if (idDepartamento) {
          url = `${API_URL}/api/ciudades?departamentoId=${idDepartamento}`;
        } else if (idPais) {
          url = `${API_URL}/api/ciudades?paisId=${idPais}`;
        }

        console.info(`[FETCH_DEBUG]: URL final: ${url}`);
        const response = await fetchWithAuth(url);
        console.info(
          `[FETCH_DEBUG]: Respuesta recibida. Status: ${response.status}`,
        );

        if (!response.ok) {
          const errorText = await response.text();
          throw new Error(`HTTP ${response.status}: ${errorText}`);
        }
        const data = await response.json();
        console.info(
          `[FETCH_DEBUG]: Datos recibidos (${Array.isArray(data) ? data.length : "no array"} registros)`,
        );
        if (Array.isArray(data) && data.length > 0) {
          console.table(data.slice(0, 5)); // [EXPERT_DEBUG]: Muestra los 5 primeros para verificar estructura.
        }
        const processedData = Array.isArray(data) ? data : [];
        setCiudades(processedData);
        setFilteredCiudades(processedData);
      } catch (err) {
        console.error("[FETCH_ERROR]: Fallo al cargar ciudades:", err);
        alert(`Error al cargar ciudades: ${err.message}`);
      }
    },
    [],
  );

  // ==============================================
  // Efectos para Carga Inicial de Datos
  // ==============================================
  useEffect(() => {
    fetchPaises();
  }, [fetchPaises]);

  // [EXPERT_ANALYSIS]: QUÉ: Se modifica el `useEffect` para cargar departamentos condicionalmente. - POR QUÉ: Ahora los departamentos se cargan solo cuando la pestaña de departamentos está activa (activeIndex === 1) y se ha seleccionado un país (`selectedCountryId`). Si no hay país seleccionado, se cargan todos los departamentos. - IMPACTO: Mejora la eficiencia al evitar cargas innecesarias y permite la funcionalidad de filtrado por país.
  useEffect(() => {
    // [EXPERT_COMMENT]: Condición para cargar departamentos - Solo se ejecuta si la pestaña activa es "Departamentos" (índice 1).
    if (activeIndex === 1) {
      // [EXPERT_COMMENT]: Carga condicional de departamentos - Si hay un país seleccionado, se cargan los departamentos de ese país; de lo contrario, se cargan todos.
      setSearchTextDepartamentos(""); // [EXPERT_DEBUG]: Reiniciar filtro visual al recargar datos
      fetchDepartamentos(selectedCountryId);
    }
  }, [activeIndex, selectedCountryId, paises, fetchDepartamentos]); // [EXPERT_COMMENT]: Dependencias del efecto.

  // [EXPERT_ANALYSIS]: QUÉ: Se modifica el `useEffect` para cargar ciudades condicionalmente. - POR QUÉ: Permite cargar ciudades basándose en la pestaña activa, el departamento seleccionado o el país seleccionado, implementando la lógica de filtrado en cascada. - IMPACTO: Habilita la funcionalidad principal de la solicitud del usuario y mejora la eficiencia de carga de datos.
  // [EXPERT_ANALYSIS]: QUÉ: Se amplía el gatillo de `useEffect` para cargar ciudades. - POR QUÉ: Para asegurar que las ciudades se carguen de forma proactiva al seleccionar un país o departamento, y no solo al entrar en la pestaña. También se añade soporte para el index 3 por si hay desajustes en la librería. - IMPACTO: Garantiza que la tabla de ciudades tenga datos tan pronto como sea posible en el flujo de cascada.
  useEffect(() => {
    // Gatillamos la carga si estamos en la pestaña de ciudades (índice 2 o 3)
    // O si se ha seleccionado un departamento/país para pre-cargar los datos.
    const isCitiesTab = activeIndex === 2 || activeIndex === 3;
    if (isCitiesTab || selectedDepartamentoId || selectedCountryId) {
      console.info(
        `[DEBUG_TRIGGER]: Gatillando fetchCiudades. activeIndex: ${activeIndex}, deptoId: ${selectedDepartamentoId}, paisId: ${selectedCountryId}`,
      );
      setSearchTextCiudades("");
      fetchCiudades(selectedDepartamentoId, selectedCountryId);
    } else {
      console.info(
        `[DEBUG_TRIGGER]: Carga omitida. activeIndex: ${activeIndex}`,
      );
    }
  }, [activeIndex, selectedDepartamentoId, selectedCountryId, fetchCiudades]);

  // ==============================================
  // Lógica de Filtrado (Búsqueda)
  // ==============================================
  const handleSearch = (e, entityType) => {
    const value = e.target.value.toLowerCase();

    // [EXPERT_HELPER]: Función para normalizar texto (quitar acentos)
    const normalizeText = (text) => {
      return text
        ? String(text)
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .toLowerCase()
        : "";
    };

    const normalizedValue = normalizeText(value);

    if (entityType === "paises") {
      setSearchTextPaises(value);
      const filtered = paises.filter(
        (p) =>
          normalizeText(p.sNombrePais).includes(normalizedValue) ||
          normalizeText(p.idpais).includes(normalizedValue),
      );
      setFilteredPaises(filtered);
    } else if (entityType === "departamentos") {
      setSearchTextDepartamentos(value);
      const filtered = departamentos.filter(
        (d) =>
          normalizeText(d.sNombreDepartamento).includes(normalizedValue) ||
          normalizeText(d.iddepartamento).includes(normalizedValue) ||
          normalizeText(d.sNombrePais).includes(normalizedValue),
      );
      setFilteredDepartamentos(filtered);
    } else if (entityType === "ciudades") {
      setSearchTextCiudades(value);
      const filtered = ciudades.filter(
        (c) =>
          normalizeText(c.sNombreCiudad).includes(normalizedValue) ||
          normalizeText(c.iCodCiudad).includes(normalizedValue) ||
          normalizeText(c.sNombreDepartamento).includes(normalizedValue) ||
          normalizeText(c.sNombrePais).includes(normalizedValue),
      );
      setFilteredCiudades(filtered);
    }
  };

  // ==============================================
  // Lógica de Modales y Formularios (Países)
  // ==============================================
  const handleNuevoPaisClick = () => {
    setIsEditModeCountry(false);
    setCountryFormData({ sNombrePais: "", idpais: "" }); // [EXPERT_ANALYSIS]: QUÉ: Se cambia `iCodPaises` a `idpais` en el estado inicial. - POR QUÉ: Para alinear la convención de nombres de propiedades con la respuesta del backend, que utiliza `idpais`. - IMPACTO: Asegura que los datos del país se manejen consistentemente en el formulario.
    setDisplayCountryModal(true);
  };

  const handleEditarPaisClick = () => {
    if (!selectedCountry) {
      alert(selectEntityAlert.replace("{entity}", "país"));
      return;
    }
    setIsEditModeCountry(true);
    setCountryFormData({
      sNombrePais: selectedCountry.sNombrePais,
      idpais: selectedCountry.idpais, // [EXPERT_ANALYSIS]: QUÉ: Se cambia `iCodPaises` a `idpais` al editar un país. - POR QUÉ: Para alinear la convención de nombres de propiedades con la respuesta del backend, que utiliza `idpais`. - IMPACTO: Asegura que los datos del país se manejen consistentemente en el formulario de edición.
    });
    setDisplayCountryModal(true);
  };

  const handleSaveCountry = async () => {
    if (!countryFormData.sNombrePais.trim()) {
      alert(nameEmptyAlert.replace("{theEntity}", "el país"));
      return;
    }
    if (!String(countryFormData.idpais).trim()) {
      // [EXPERT_ANALYSIS]: QUÉ: Se cambia `countryFormData.iCodPaises` a `countryFormData.idpais` en la validación. - POR QUÉ: Para alinear la convención de nombres de propiedades con la respuesta del backend, que utiliza `idpais`. - IMPACTO: La validación del código del país funcionará correctamente.
      // [EXPERT_ANALYSIS]: QUÉ: Se convierte `countryFormData.iCodPaises` a String antes de llamar a `trim()`. - POR QUÉ: El error `TypeError: .trim is not a function` ocurre porque `iCodPaises` no es una cadena. Convertirlo a String asegura que `trim()` siempre se aplique a un tipo de dato válido. - IMPACTO: Corrige el error de tiempo de ejecución y mejora la robustez del formulario de países.
      alert(codeEmptyAlert.replace("{theEntity}", "el país"));
      return;
    }

    try {
      let response;
      if (isEditModeCountry) {
        response = await fetchWithAuth(
          `${API_URL}/api/paises/editar-pais/${countryFormData.idpais}`,
          {
            // [EXPERT_ANALYSIS]: QUÉ: Se cambia `countryFormData.iCodPaises` a `countryFormData.idpais` en la URL de edición. - POR QUÉ: El backend espera `idpais` como parámetro de ruta. Esta corrección asegura que la solicitud de edición se dirija al recurso correcto. - IMPACTO: Permite la edición exitosa de países.
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(countryFormData),
          },
        );
      } else {
        response = await fetchWithAuth(`${API_URL}/api/paises/crear-pais`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(countryFormData),
        });
      }

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Error en la operación");
      }

      console.log(
        `País ${isEditModeCountry ? "actualizado" : "creado"} exitosamente:`,
        countryFormData,
      );
      setDisplayCountryModal(false);
      setCountryFormData({ sNombrePais: "", idpais: "" }); // [EXPERT_ANALYSIS]: QUÉ: Se cambia `iCodPaises` a `idpais` al resetear el formulario. - POR QUÉ: Para mantener la consistencia con la nueva convención de nombres de propiedades. - IMPACTO: El formulario se reseteará correctamente después de guardar.
      fetchPaises();
      alert(
        isEditModeCountry
          ? editSuccess.replace("{Entity}", "País")
          : createSuccess.replace("{Entity}", "País"),
      );
    } catch (err) {
      console.error(
        `Error al ${isEditModeCountry ? "actualizar" : "crear"} el país:`,
        err,
      );
      alert(
        `${isEditModeCountry ? editError.replace("{theEntity}", "el país") : createError.replace("{theEntity}", "el país")}${err.message}`,
      );
    }
  };

  // ==============================================
  // Lógica de Modales y Formularios (Departamentos)
  // ==============================================
  const handleNuevoDepartamentoClick = () => {
    setIsEditModeDepartamento(false);
    setDepartamentoFormData({
      // [EXPERT_ANALYSIS]: QUÉ: Se inicializa `departamentoFormData` para un nuevo departamento. - POR QUÉ: Se establece `sNombreDepartamento` y `iCodDepartamento` como cadenas vacías para un nuevo registro. `iCodPaises` se inicializa con el `selectedCountryId` para pre-seleccionar el país si ya hay uno elegido en la pestaña de países, mejorando la usabilidad. - IMPACTO: Permite que el modal de "Nuevo Departamento" muestre el país seleccionado por defecto, agilizando el flujo de trabajo del usuario.
      sNombreDepartamento: "",
      iddepartamento: "", // [EXPERT_ANALYSIS]: QUÉ: Se cambia `iCodDepartamento` a `iddepartamento` en la inicialización del formulario de departamento. - POR QUÉ: Para alinear la convención de nombres de propiedades con la respuesta del backend, que utiliza `iddepartamento`. - IMPACTO: El formulario de departamento se inicializará con el ID de departamento correcto.
      idpais: selectedCountryId || "", // [EXPERT_ANALYSIS]: QUÉ: Se cambia `iCodPaises` a `idpais` en la inicialización del formulario de departamento. - POR QUÉ: Para alinear la convención de nombres de propiedades con la respuesta del backend, que utiliza `idpais`. - IMPACTO: Asegura que los datos del país se manejen consistentemente en el formulario.
    });
    setDisplayDepartamentoModal(true);
  };

  const handleEditarDepartamentoClick = () => {
    if (!selectedDepartamento) {
      alert(selectEntityAlert.replace("{entity}", "departamento"));
      return;
    }
    setIsEditModeDepartamento(true);
    setDepartamentoFormData({
      sNombreDepartamento: selectedDepartamento.sNombreDepartamento,
      iddepartamento: selectedDepartamento.iddepartamento, // [EXPERT_ANALYSIS]: QUÉ: Se cambia `iCodDepartamento` a `iddepartamento` al editar un departamento. - POR QUÉ: Para alinear la convención de nombres de propiedades con la respuesta del backend, que utiliza `iddepartamento`. - IMPACTO: El formulario de edición de departamento mostrará el ID de departamento correcto.
      idpais: selectedDepartamento.idpais, // [EXPERT_ANALYSIS]: QUÉ: Se cambia `iCodPaises` a `idpais` al editar un departamento. - POR QUÉ: Para alinear la convención de nombres de propiedades con la respuesta del backend, que utiliza `idpais`. - IMPACTO: El formulario de edición de departamento mostrará el ID de país correcto.
    });
    setDisplayDepartamentoModal(true);
  };

  const handleSaveDepartamento = async () => {
    if (!departamentoFormData.sNombreDepartamento.trim()) {
      alert(nameEmptyAlert.replace("{theEntity}", "el departamento"));
      return;
    }
    if (!String(departamentoFormData.iddepartamento || "").trim()) {
      alert(codeEmptyAlert.replace("{theEntity}", "el departamento"));
      return;
    }
    if (!departamentoFormData.idpais) {
      // [EXPERT_ANALYSIS]: QUÉ: Se cambia `departamentoFormData.iCodPaises` a `departamentoFormData.idpais` en la validación. - POR QUÉ: Para alinear la convención de nombres de propiedades con la respuesta del backend, que utiliza `idpais`. - IMPACTO: La validación del país asociado al departamento funcionará correctamente.
      alert(
        mustBeAssociated
          .replace("{entity}", "departamento")
          .replace("{parentEntity}", "país"),
      );
      return;
    }

    try {
      let response;
      if (isEditModeDepartamento) {
        response = await fetchWithAuth(
          `${API_URL}/api/departamentos/editar-departamento/${departamentoFormData.iddepartamento}`,
          {
            // [EXPERT_ANALYSIS]: QUÉ: Se cambia `departamentoFormData.iCodDepartamento` a `iddepartamento` en la URL de edición. - POR QUÉ: El backend espera `iddepartamento` como parámetro de ruta para la edición. Esta corrección asegura que la solicitud se dirija al recurso correcto. - IMPACTO: Permite la edición exitosa de departamentos.
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(departamentoFormData),
          },
        );
      } else {
        response = await fetchWithAuth(
          `${API_URL}/api/departamentos/crear-departamento`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(departamentoFormData),
          },
        );
      }

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Error en la operación");
      }

      console.log(
        `Departamento ${isEditModeDepartamento ? "actualizado" : "creado"} exitosamente:`,
        departamentoFormData,
      );
      setDisplayDepartamentoModal(false);
      setDepartamentoFormData({
        sNombreDepartamento: "",
        iddepartamento: "",
        idpais: "",
      }); // [EXPERT_ANALYSIS]: QUÉ: Se cambia `iCodDepartamento` a `iddepartamento` al resetear el formulario de departamento. - POR QUÉ: Para mantener la consistencia con la nueva convención de nombres de propiedades. - IMPACTO: El formulario de departamento se reseteará correctamente después de guardar.
      fetchDepartamentos();
      alert(
        isEditModeDepartamento
          ? editSuccess.replace("{Entity}", "Departamento")
          : createSuccess.replace("{Entity}", "Departamento"),
      );
    } catch (err) {
      console.error(
        `Error al ${isEditModeDepartamento ? "actualizar" : "crear"} el departamento:`,
        err,
      );
      alert(
        `${isEditModeDepartamento ? editError.replace("{theEntity}", "el departamento") : createError.replace("{theEntity}", "el departamento")}${
          err.message
        }`,
      );
    }
  };

  // ==============================================
  // Lógica de Modales y Formularios (Ciudades)
  // ==============================================
  const handleNuevoCiudadClick = async () => {
    setIsEditModeCiudad(false);

    let nextId = "";
    try {
      // [EXPERT_ANALYSIS]: Generación autónoma del ID basado en el máximo global.
      const response = await fetchWithAuth(`${API_URL}/api/ciudades`);
      const allCiudades = await response.json();
      if (allCiudades && allCiudades.length > 0) {
        const maxId = Math.max(
          ...allCiudades.map((c) => parseInt(c.iCodCiudad) || 0),
        );
        nextId = (maxId + 1).toString();
      } else {
        nextId = "1";
      }
    } catch (err) {
      console.error("Error al generar ID automático:", err);
    }

    setCiudadFormData({
      sNombreCiudad: "",
      iCodCiudad: nextId,
      iddepartamento: selectedDepartamentoId || "",
      idpais: selectedCountryId || "",
    });
    setDisplayCiudadModal(true);
  };

  const handleEditarCiudadClick = () => {
    if (!selectedCiudad) {
      alert(selectEntityAlert.replace("{entity}", "ciudad"));
      return;
    }
    setIsEditModeCiudad(true);
    setCiudadFormData({
      sNombreCiudad: selectedCiudad.sNombreCiudad,
      iCodCiudad: selectedCiudad.iCodCiudad,
      iddepartamento: selectedCiudad.iddepartamento,
      idpais: selectedCiudad.idpais,
    });
    setDisplayCiudadModal(true);
  };

  const handleSaveCiudad = async () => {
    if (!ciudadFormData.sNombreCiudad.trim()) {
      alert(nameEmptyAlert.replace("{theEntity}", "la ciudad"));
      return;
    }
    if (!String(ciudadFormData.iCodCiudad || "").trim()) {
      alert(codeEmptyAlert.replace("{theEntity}", "la ciudad"));
      return;
    }
    if (!ciudadFormData.iddepartamento) {
      alert(
        mustBeAssociated
          .replace("{entity}", "ciudad")
          .replace("{parentEntity}", "departamento"),
      );
      return;
    }

    try {
      let response;
      if (isEditModeCiudad) {
        response = await fetchWithAuth(
          `${API_URL}/api/ciudades/editar-ciudad/${ciudadFormData.iCodCiudad}`,
          {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(ciudadFormData),
          },
        );
      } else {
        response = await fetchWithAuth(`${API_URL}/api/ciudades/crear-ciudad`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(ciudadFormData),
        });
      }

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Error en la operación");
      }

      console.log(
        `Ciudad ${isEditModeCiudad ? "actualizada" : "creada"} exitosamente:`,
        ciudadFormData,
      );
      setDisplayCiudadModal(false);
      setCiudadFormData({
        sNombreCiudad: "",
        iCodCiudad: "",
        iddepartamento: "",
        idpais: "",
      });
      fetchCiudades();
      alert(
        isEditModeCiudad
          ? editSuccess.replace("{Entity}", "Ciudad")
          : createSuccess.replace("{Entity}", "Ciudad"),
      );
    } catch (err) {
      console.error(
        `Error al ${isEditModeCiudad ? "actualizar" : "crear"} la ciudad:`,
        err,
      );
      alert(
        `${isEditModeCiudad ? editError.replace("{theEntity}", "la ciudad") : createError.replace("{theEntity}", "la ciudad")}${err.message}`,
      );
    }
  };

  // ==============================================
  // Efecto para filtrar departamentos en el modal de ciudad
  // ==============================================
  useEffect(() => {
    if (ciudadFormData.idpais) {
      const fetchFilteredDeptos = async () => {
        try {
          // [EXPERT_ANALYSIS]: Corrección de ruta. El backend usa /:paisId para filtrar departamentos.
          const response = await fetchWithAuth(
            `${API_URL}/api/departamentos/${ciudadFormData.idpais}`,
          );
          if (!response.ok)
            throw new Error(
              "Error al cargar departamentos por país para ciudad",
            );
          const data = await response.json();
          setDepartamentosFiltradosParaCiudad(data);
        } catch (err) {
          console.error(
            `Error al cargar departamentos para el país ${ciudadFormData.idpais} (modal ciudad):`,
            err,
          );
          setDepartamentosFiltradosParaCiudad([]);
          alert(
            `Error al cargar departamentos para el país seleccionado: ${err.message}`,
          );
        }
      };
      fetchFilteredDeptos();
    } else {
      setDepartamentosFiltradosParaCiudad([]);
      setCiudadFormData((prev) => ({ ...prev, iddepartamento: "" }));
    }
  }, [ciudadFormData.idpais]);
  // [EXPERT_ANALYSIS]: Efecto para verificar duplicidad de código de ciudad en tiempo real.
  useEffect(() => {
    const cityCode = String(ciudadFormData.iCodCiudad || "");
    if (cityCode.trim().length > 0 && !isEditModeCiudad) {
      const checkDuplicate = async () => {
        try {
          // Usamos la ruta de obtención normal para verificar si ya existe.
          const response = await fetchWithAuth(`${API_URL}/api/ciudades`);
          const allCiudades = await response.json();
          const exists = allCiudades.some(
            (c) => String(c.iCodCiudad) === cityCode.trim(),
          );
          setIsDuplicateCode(exists);
        } catch (err) {
          console.error("Error al verificar duplicidad:", err);
        }
      };
      const timer = setTimeout(checkDuplicate, 500); // Debounce de 500ms
      return () => clearTimeout(timer);
    } else {
      setIsDuplicateCode(false);
    }
  }, [ciudadFormData.iCodCiudad, isEditModeCiudad]);

  // ==============================================
  // Renderizado Principal con TabView
  // ==============================================
  return (
    <div className="contenedorprincipal pagina-ubicaciones">
      <h1 className="titulo">
        {translations.gestion_ubicaciones || "Gestión de Ubicaciones"}
      </h1>
      <TabView
        activeIndex={activeIndex}
        onTabChange={(e) => {
          console.info(
            `[INDEX_DEBUG]: Cambio de pestaña detectado. Nuevo index: ${e.index}`,
          );
          setActiveIndex(e.index);
        }}
      >
        {/* Pestaña de Países */}
        <TabPanel header={titlePaises}>
          <div className="botonessuperiores">
            <Button
              id="btn-paises-nuevo"
              label={newButton}
              icon="pi pi-plus"
              className="p-button-success"
              onClick={handleNuevoPaisClick}
            />{" "}
            <Button
              id="btn-paises-editar"
              label={editButton}
              icon="pi pi-pencil"
              className="p-button-warning"
              onClick={handleEditarPaisClick}
            />{" "}
          </div>
          <div style={{ marginBottom: "2px", textAlign: "center" }}>
            <InputText
              id="filtro-paises-search"
              type="text"
              placeholder={searchPlaceholder}
              value={searchTextPaises}
              onChange={(e) => handleSearch(e, "paises")}
              style={{ padding: "5px", width: "200px" }}
            />
          </div>
          <DataTable
            value={filteredPaises}
            dataKey="idpais" // [EXPERT_ANALYSIS]: Añadido dataKey para mejorar estabilidad de selección.
            paginator
            rows={13}
            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport"
            currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} países"
            responsiveLayout="scroll"
            selectionMode="single"
            selection={selectedCountry}
            // [EXPERT_ANALYSIS]: QUÉ: Se modifica el `onSelectionChange` para actualizar `selectedCountryId`. - POR QUÉ: Es crucial para que la pestaña de departamentos sepa qué país ha sido seleccionado y pueda filtrar los departamentos correspondientes. - IMPACTO: Habilita la interconexión entre la selección de país y la visualización de departamentos.
            onSelectionChange={(e) => {
              const val = e.value;
              setSelectedCountry(val);
              setSelectedCountryId(val ? val.idpais : null);
              setSelectedDepartamento(null);
              setSelectedDepartamentoId(null);
              setSelectedCiudad(null);
              if (val) setActiveIndex(1); // [EXPERT_ANALYSIS]: Salto automático a Departamentos.
              console.info(
                `[DEBUG_FLOW]: País seleccionado: ${val ? val.idpais : "Ninguno"}. Saltando a pestaña 1.`,
              );
            }}
            sortMode="multiple"
            stripedRows
            showGridlines
            removableSort
          >
            {columnsPaises.map((col, index) => (
              <Column
                key={index}
                field={col.field}
                header={col.header}
                body={(rowData) => {
                  return (
                    <span id={`pais-celda-${rowData.idpais}-${col.field}`}>
                      {rowData[col.field]}
                    </span>
                  );
                }}
                sortable
              />
            ))}
          </DataTable>
        </TabPanel>

        {/* Pestaña de Departamentos */}
        <TabPanel header={titleDepartamentos}>
          <div className="botonessuperiores">
            <Button
              id="btn-departamentos-nuevo"
              label={newButton}
              icon="pi pi-plus"
              className="p-button-success"
              onClick={handleNuevoDepartamentoClick}
            />{" "}
            <Button
              id="btn-departamentos-editar"
              label={editButton}
              icon="pi pi-pencil"
              className="p-button-warning"
              onClick={handleEditarDepartamentoClick}
            />{" "}
          </div>
          <div style={{ marginBottom: "2px", textAlign: "center" }}>
            <InputText
              id="filtro-departamentos-search"
              type="text"
              placeholder={searchPlaceholder}
              value={searchTextDepartamentos}
              onChange={(e) => handleSearch(e, "departamentos")}
              style={{ padding: "5px", width: "200px" }}
            />
          </div>
          {/* [EXPERT_ANALYSIS]: QUÉ: Se añade un renderizado condicional para la tabla de departamentos. - POR QUÉ: Muestra un mensaje si no se ha seleccionado un país, guiando al usuario. Si hay un país seleccionado, muestra la tabla de departamentos filtrados. - IMPACTO: Mejora la experiencia de usuario y la claridad de la interfaz. */}
          {/* [EXPERT_ANALYSIS]: QUÉ: Se elimina la condición de renderizado condicional para la tabla de departamentos. - POR QUÉ: La tabla de departamentos ahora se renderizará siempre, independientemente de si hay un país seleccionado o no, mostrando todos los departamentos si no hay un país filtrado. - IMPACTO: Permite que la tabla de departamentos sea siempre visible y funcional, mejorando la usabilidad. */}
          <DataTable // [EXPERT_COMMENT]: Se elimina la condición `selectedCountryId ? (...) : (...)` para que la tabla se muestre siempre.
            value={filteredDepartamentos}
            dataKey="iddepartamento" // [EXPERT_ANALYSIS]: Añadido dataKey.
            paginator
            rows={13}
            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport"
            currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} departamentos"
            responsiveLayout="scroll"
            selectionMode="single"
            selection={selectedDepartamento}
            onSelectionChange={(e) => {
              const val = e.value;
              console.info(`[DEBUG_SELECTION]: Seleccionando depto:`, val);
              setSelectedDepartamento(val);
              setSelectedDepartamentoId(val ? val.iddepartamento : null);
              setSelectedCiudad(null);
              if (val) {
                console.info(
                  `[DEBUG_NAV]: Saltando a pestaña Ciudades con deptoId: ${val.iddepartamento}`,
                );
                setActiveIndex(2);
              }
            }}
            sortMode="multiple"
            stripedRows
            showGridlines
            removableSort
          >
            {columnsDepartamentos.map((col, index) => (
              <Column
                key={index}
                field={col.field}
                header={col.header}
                body={(rowData) => {
                  return (
                    <span
                      id={`departamento-celda-${rowData.iddepartamento}-${col.field}`}
                    >
                      {rowData[col.field]}
                    </span>
                  );
                }}
                sortable
              />
            ))}
          </DataTable>
          {/* [EXPERT_COMMENT]: Se elimina el párrafo que mostraba el mensaje "Por favor, selecciona un país..." ya que la tabla se renderiza siempre. */}
        </TabPanel>

        {/* Pestaña de Ciudades */}
        <TabPanel header={titleCiudades}>
          <div className="botonessuperiores">
            <Button
              id="btn-ciudades-nuevo"
              label={newButton}
              icon="pi pi-plus"
              className="p-button-success"
              onClick={handleNuevoCiudadClick}
            />{" "}
            <Button
              id="btn-ciudades-editar"
              label={editButton}
              icon="pi pi-pencil"
              className="p-button-warning"
              onClick={handleEditarCiudadClick}
            />{" "}
          </div>
          <div style={{ marginBottom: "2px", textAlign: "center" }}>
            <InputText
              id="filtro-ciudades-search"
              type="text"
              placeholder={searchPlaceholder}
              value={searchTextCiudades}
              onChange={(e) => handleSearch(e, "ciudades")}
              style={{ padding: "5px", width: "200px" }}
            />
          </div>
          {/* [EXPERT_ANALYSIS]: Se elimina el condicional para que la tabla sea siempre visible, mejorando la UX y la depuración. */}
          <DataTable
            value={filteredCiudades}
            dataKey="iCodCiudad" // [EXPERT_ANALYSIS]: Añadido dataKey.
            paginator
            rows={13}
            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport"
            currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} ciudades"
            responsiveLayout="scroll"
            selectionMode="single"
            selection={selectedCiudad}
            onSelectionChange={(e) => setSelectedCiudad(e.value)}
            sortMode="multiple"
            stripedRows
            showGridlines
            removableSort
          >
            {columnsCiudades.map((col, index) => (
              <Column
                key={index}
                field={col.field}
                header={col.header}
                body={(rowData) => {
                  return (
                    <span
                      id={`ciudad-celda-${rowData.iCodCiudad}-${col.field}`}
                    >
                      {rowData[col.field]}
                    </span>
                  );
                }}
                sortable
              />
            ))}
          </DataTable>
        </TabPanel>
      </TabView>

      {/* [EXPERT_ANALYSIS]: Diálogos movidos fuera del TabView para estabilidad. */}
      {/* Diálogo de Países */}
      <Dialog
        header={
          isEditModeCountry
            ? editHeader.replace("{entity}", "País")
            : newHeader.replace("{entity}", "País")
        }
        visible={displayCountryModal}
        style={{ width: "30vw" }}
        onHide={() => setDisplayCountryModal(false)}
        modal
      >
        <div className="p-fluid">
          <div className="p-field">
            <label htmlFor="countryCode">{codeLabel}</label>
            <InputText
              id="input-pais-codigo"
              name="idpais"
              value={countryFormData.idpais}
              onChange={(e) =>
                setCountryFormData({
                  ...countryFormData,
                  idpais: e.target.value,
                })
              }
              required
              disabled={isEditModeCountry}
            />
          </div>
          <div className="p-field">
            <label htmlFor="countryName">{nameLabel}</label>
            <InputText
              id="input-pais-nombre"
              name="sNombrePais"
              value={countryFormData.sNombrePais}
              onChange={(e) =>
                setCountryFormData({
                  ...countryFormData,
                  sNombrePais: e.target.value,
                })
              }
              required
            />
          </div>
          <div className="p-dialog-footer" style={{ marginTop: "20px" }}>
            <Button
              id="btn-pais-cancelar"
              label={cancelButton}
              icon="pi pi-times"
              className="p-button-text"
              onClick={() => setDisplayCountryModal(false)}
            />
            <Button
              id="btn-pais-guardar"
              label={saveButton}
              icon="pi pi-check"
              onClick={handleSaveCountry}
            />
          </div>
        </div>
      </Dialog>

      {/* Diálogo de Departamentos */}
      <Dialog
        header={
          isEditModeDepartamento
            ? editHeader.replace("{entity}", "Departamento")
            : newHeader.replace("{entity}", "Departamento")
        }
        visible={displayDepartamentoModal}
        style={{ width: "30vw" }}
        onHide={() => setDisplayDepartamentoModal(false)}
        modal
      >
        <div className="p-fluid">
          <div className="p-field">
            <label htmlFor="departamentoCode">{codeLabel}</label>
            <InputText
              id="input-departamento-codigo"
              name="iddepartamento"
              value={departamentoFormData.iddepartamento}
              onChange={(e) =>
                setDepartamentoFormData({
                  ...departamentoFormData,
                  iddepartamento: e.target.value,
                })
              }
              required
              disabled={isEditModeDepartamento}
            />
          </div>
          <div className="p-field">
            <label htmlFor="departamentoName">{nameLabel}</label>
            <InputText
              id="input-departamento-nombre"
              name="sNombreDepartamento"
              value={departamentoFormData.sNombreDepartamento}
              onChange={(e) =>
                setDepartamentoFormData({
                  ...departamentoFormData,
                  sNombreDepartamento: e.target.value,
                })
              }
              required
            />
          </div>
          <div className="p-field">
            <label htmlFor="paisDepartamento">{countryLabel}</label>
            <Dropdown
              id="dropdown-departamento-pais"
              name="idpais"
              value={departamentoFormData.idpais}
              options={paises}
              optionLabel="sNombrePais"
              optionValue="idpais"
              onChange={(e) =>
                setDepartamentoFormData({
                  ...departamentoFormData,
                  idpais: e.value,
                })
              }
              placeholder="Seleccione un país"
              required
            />
          </div>
          <div className="p-dialog-footer" style={{ marginTop: "20px" }}>
            <Button
              id="btn-departamento-cancelar"
              label={cancelButton}
              icon="pi pi-times"
              className="p-button-text"
              onClick={() => setDisplayDepartamentoModal(false)}
            />
            <Button
              id="btn-departamento-guardar"
              label={saveButton}
              icon="pi pi-check"
              onClick={handleSaveDepartamento}
            />
          </div>
        </div>
      </Dialog>

      {/* Diálogo de Ciudades */}
      <Dialog
        header={
          isEditModeCiudad
            ? editHeader.replace("{entity}", "Ciudad")
            : newHeader.replace("Nuevo", "Nueva").replace("{entity}", "Ciudad")
        }
        visible={displayCiudadModal}
        style={{ width: "30vw" }}
        onHide={() => setDisplayCiudadModal(false)}
        modal
      >
        <div className="p-fluid">
          <div className="p-field">
            <label htmlFor="ciudadCode">{codeLabel}</label>
            <InputText
              id="input-ciudad-codigo"
              name="iCodCiudad"
              value={ciudadFormData.iCodCiudad}
              onChange={(e) =>
                setCiudadFormData({
                  ...ciudadFormData,
                  iCodCiudad: e.target.value,
                })
              }
              className={isDuplicateCode ? "p-invalid" : ""}
              required
              disabled={isEditModeCiudad}
            />
            {isDuplicateCode && (
              <small
                className="p-error"
                style={{ display: "block", marginTop: "4px" }}
              >
                Este código ya existe para otra ciudad.
              </small>
            )}
          </div>
          <div className="p-field">
            <label htmlFor="ciudadName">{nameLabel}</label>
            <InputText
              id="input-ciudad-nombre"
              name="sNombreCiudad"
              value={ciudadFormData.sNombreCiudad}
              onChange={(e) =>
                setCiudadFormData({
                  ...ciudadFormData,
                  sNombreCiudad: e.target.value,
                })
              }
              required
            />
          </div>
          <div className="p-field">
            <label htmlFor="paisCiudad">{countryLabel}</label>
            <Dropdown
              id="dropdown-ciudad-pais"
              name="idpais"
              value={ciudadFormData.idpais}
              options={paises}
              optionLabel="sNombrePais"
              optionValue="idpais"
              onChange={(e) => {
                setCiudadFormData((prev) => ({
                  ...prev,
                  idpais: e.value,
                  iddepartamento: "",
                }));
              }}
              placeholder="Seleccione un país"
              required
            />
          </div>
          <div className="p-field">
            <label htmlFor="departamentoCiudad">{departmentLabel}</label>
            <Dropdown
              id="dropdown-ciudad-departamento"
              name="iddepartamento"
              value={ciudadFormData.iddepartamento}
              options={departamentosFiltradosParaCiudad}
              optionLabel="sNombreDepartamento"
              optionValue="iddepartamento"
              onChange={(e) =>
                setCiudadFormData((prev) => ({
                  ...prev,
                  iddepartamento: e.value,
                }))
              }
              placeholder="Seleccione un departamento"
              required
              disabled={
                !ciudadFormData.idpais ||
                departamentosFiltradosParaCiudad.length === 0
              }
            />
          </div>
          <div className="p-dialog-footer" style={{ marginTop: "20px" }}>
            <Button
              id="btn-ciudad-cancelar"
              label={cancelButton}
              icon="pi pi-times"
              className="p-button-text"
              onClick={() => setDisplayCiudadModal(false)}
            />
            <Button
              id="btn-ciudad-guardar"
              label={saveButton}
              icon="pi pi-check"
              onClick={handleSaveCiudad}
            />
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default Paises;
